import { useEffect, useState } from "react";
import Lenis from "@studio-freight/lenis";
import Loader from "../components/Loader/Loader";
import Header from "../components/header/Header";
import Main from "../components/main/Main";
import Footer from "../components/footer/Footer";
import Cursor from "../components/cursor/Cursor";

const App = () => {
  const [navActive, setNavActive] = useState("home");
  const [loader, setLoader] = useState(true);

  // Smooth Page Scrolling
  useEffect(() => {
    const lenis = new Lenis();

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  useEffect(() => {
    setTimeout(() => setLoader(false), 3000);
  }, []);

  if (loader) return <Loader />;
  return (
    <>
      <Cursor />
      <Header navActive={navActive} setNavActive={setNavActive} />
      <Main />
      <Footer />
    </>
  );
};

export default App;
